import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { AccountUid } from 'interfaces/linkage'

type SetFilterByAccountsPayload = {
  uids: Record<AccountUid, boolean>
}
type SetFilterByAccountsResponse = {
  disabled_accounts: AccountUid[]
}
export class SetFilterByAccountsAction extends createRequestAction<'SET_FILTER_BY_ACCOUNTS', SetFilterByAccountsPayload, SetFilterByAccountsResponse>('SET_FILTER_BY_ACCOUNTS') {}

type ToggleComparisonActionPayload = {
  isEnabled: boolean
}
type ToggleComparisonActionResponse = {
  isEnabled: boolean
}
export class ToggleComparisonAction extends createRequestAction<'TOGGLE_COMPARISON', ToggleComparisonActionPayload, ToggleComparisonActionResponse>('TOGGLE_COMPARISON') {}

export type PageFilterActions =
  | typeof SetFilterByAccountsAction.Type
  | typeof ToggleComparisonAction.Type
